import React from "react";

// Label row of the lobby's "Room settings" summary. The host's editor lives
// behind a small gear in the Room card, which players kept missing (they asked
// why they couldn't change categories), so the host gets a visible Change
// link here and guests are told the host decides.
export default function RoomSettingsLabel({ canEdit = false, isGuest = false, onEdit }) {
  return (
    <div className="flex items-baseline justify-between gap-3">
      <span className="text-xs font-bold uppercase tracking-wide text-gray-400">Room settings</span>
      {canEdit && (
        <button
          onClick={onEdit}
          aria-label="Change room settings"
          className="text-sm font-semibold text-red-600 hover:text-red-700"
        >
          Change
        </button>
      )}
      {isGuest && <span className="text-xs text-gray-400">Set by the host</span>}
    </div>
  );
}
